import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgArrowLeft = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M24.5 14a.875.875 0 0 1-.875.875H6.487l6.382 6.38a.875.875 0 1 1-1.238 1.24l-7.875-7.876a.876.876 0 0 1 0-1.238l7.875-7.875a.876.876 0 0 1 1.238 1.238l-6.382 6.381h17.138A.875.875 0 0 1 24.5 14Z" />
  </svg>
);
export default SvgArrowLeft;
